import ContactFormPro from "@/components/feature/ContactFormPro";
import GoogleReviews from "@/components/feature/GoogleReviews";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PiecesSection from "@/components/feature/PiecesSection";
import ServicesSection from "@/components/feature/ServicesSection";
import { getVillePieces, getVilleServices } from "@/mocks/servicesSections";
import VideoDiagnostic from "@/components/feature/VideoDiagnostic";
import { useSEO } from "@/hooks/useSEO";
import { seoData } from "@/data/seoData";
import Hero from "./components/Hero";
import LocalIntro from "./components/LocalIntro";
import InterventionsGrid from "./components/InterventionsGrid";
import FAQ from "./components/FAQ";
import Gallery from "./components/Gallery";
import InternalLinks from "./components/InternalLinks";
import FloatingButton from "./components/FloatingButton";

function ContactFormLingolsheim() {
  return (
    <ContactFormPro
      variant="inline"
      formId="devis-form-lingolsheim"
      ctaTitle="Besoin d'un réparateur de fenêtre à Lingolsheim ?"
      ctaSubtitle="Appel gratuit, devis sans engagement. Intervention possible le jour même."
    />
  );
}

export default function ReparationFenetreLingolsheimPage() {
  useSEO(seoData.reparationFenetreLingolsheim);
  return (
    <>
      <Header />
      <main>
        <Hero />
        <VideoDiagnostic />
        <PiecesSection {...getVillePieces("Lingolsheim")} />
        <ServicesSection {...getVilleServices("Lingolsheim")} />
        <LocalIntro />
        <InterventionsGrid />
        <FAQ />
        <Gallery />
        <InternalLinks />
        <GoogleReviews />
        <ContactFormLingolsheim />
      </main>
      <Footer />
      <FloatingButton />
    </>
  );
}